/**
 * チャット（WhatsApp等）からコピー・共有された本文の頭書きを外す（docs/08 §202）。
 *
 * WhatsAppでメッセージを1件だけコピーすると本文だけが入るが、複数件を選んで
 * コピーしたり、チャットを書き出したりすると、行の頭に送信日時と送り主が付く:
 *
 *   [14:49, 2025/11/3] SIBF25 Notification: Pibal Data released on 13:30 3rd Nov   （iPhone・日本語）
 *   [2025/11/03 14:49:12] SIBF25 Notification: Pibal Data …                         （書き出し）
 *   2025/11/03 14:49 - SIBF25 Notification: Pibal Data …                            （Android）
 *
 * 頭書きは外し、最初に見つかった送信日時を配信時刻の手がかりとして返す
 * （本文に「10/10 07:00」のような配信時刻が無いときに使う）。
 * 日付が「日/月/年」か「月/日/年」かは決められないので、年が先頭の形だけを読む。
 */

const pad2 = (n: number | string) => String(n).padStart(2, '0');

const HEADERS: Array<{ re: RegExp; at: (m: RegExpExecArray) => string }> = [
  // [14:49, 2025/11/3] 名前:
  {
    re: /^\[(\d{1,2}):(\d{2})(?::\d{2})?,\s*(\d{4})[/.-](\d{1,2})[/.-](\d{1,2})\]\s*[^:]{0,80}:\s?/,
    at: (m) => `${m[3]}-${pad2(m[4])}-${pad2(m[5])}T${pad2(m[1])}:${m[2]}`,
  },
  // [2025/11/03 14:49:12] 名前:
  {
    re: /^\[(\d{4})[/.-](\d{1,2})[/.-](\d{1,2}),?\s+(\d{1,2}):(\d{2})(?::\d{2})?\]\s*[^:]{0,80}:\s?/,
    at: (m) => `${m[1]}-${pad2(m[2])}-${pad2(m[3])}T${pad2(m[4])}:${m[5]}`,
  },
  // 2025/11/03 14:49 - 名前:
  {
    re: /^(\d{4})[/.-](\d{1,2})[/.-](\d{1,2}),?\s+(\d{1,2}):(\d{2})(?::\d{2})?\s+-\s+[^:]{0,80}:\s?/,
    at: (m) => `${m[1]}-${pad2(m[2])}-${pad2(m[3])}T${pad2(m[4])}:${m[5]}`,
  },
];

export interface StrippedChatText {
  /** 頭書きを外した本文 */
  text: string;
  /** 最初の頭書きの送信日時（現地、YYYY-MM-DDTHH:MM）。頭書きが無ければ null */
  sentLocal: string | null;
}

export function stripChatHeaders(raw: string): StrippedChatText {
  let sentLocal: string | null = null;
  const lines = raw.split(/\r?\n/).map((line) => {
    for (const h of HEADERS) {
      const m = h.re.exec(line);
      if (m) {
        sentLocal ??= h.at(m);
        return line.slice(m[0].length);
      }
    }
    return line;
  });
  return { text: lines.join('\n'), sentLocal };
}
